module.exports = __webpack_public_path__ + "img/nataliya-yuferova.4deed5cd.jpg";